import React from 'react';
import Reflux from 'reflux';
import { Row, Col } from 'bootstrap';
import EventDateRange from 'main/components/event/dateRange';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import RouteActions from 'flux/actions/RouteActions';
import EventViewStore from 'flux/stores/EventViewStore';
import TeamViewStore from 'flux/stores/TeamViewStore';
import EventViewActions from 'flux/actions/EventViewActions';
import EventShowListStore from 'flux/stores/EventShowListStore';
import EventShowListActions from 'flux/actions/EventShowListActions';
import GuestCuesheetStore from 'flux/stores/cuesheet.guest/GuestCuesheetStore';
import TeamViewActions from 'flux/actions/TeamViewActions';

export default React.createClass({
  displayName: 'guestPassShowPage',

  mixins: [
    Reflux.connect(GuestCuesheetStore, 'cuesheet'),
    Reflux.connectFilter(EventShowListStore, 'shows', (state) =>
      state.get('shows'),
    ),
    Reflux.connect(EventViewStore, 'event'),
    Reflux.connect(TeamViewStore, 'team'),
  ],

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  componentWillMount() {
    const { teamId, eventId } = this.context.router.state.params;

    EventViewActions.populateForGuest(teamId, eventId);
    EventShowListActions.populateForGuest(teamId, eventId);
    TeamViewActions.populateForGuest(teamId);
  },

  render() {
    const { event } = this.state;

    if (!event) return;

    const message =
      'To have guest pass enabled for this link please contact your event admin.';

    if (!event.get('guestPass')) {
      return (
        <div className="text-center">
          <h3>The guest pass for this event is disabled.</h3>
          <h5>{message}</h5>
        </div>
      );
    }

    const headerNode = this._getHeaderNode();
    const bodyNode = this._getBodyNode();

    const footerNode = (
      <footer className="guest-pass-event-lander-footer">
        <span className="guest-pass-event-lander-footer-text">Powered by</span>
        <a target="_blank" rel="noopener noreferrer" href="https://shoflo.tv">
          <img
            role="presentation"
            className="cs-footer-logo-light"
            src={`${window.shofloAssetBaseUrl}/logo.png`}
          />
        </a>
      </footer>
    );

    return (
      <div className="guest-pass-event-lander-wrapper">
        {headerNode}
        {bodyNode}
        {footerNode}
      </div>
    );
  },

  _getHeaderNode() {
    return (
      <header className="guest-pass-event-lander-header">
        <Row>
          <Col xs={24} sm={18} smOffset={3}>
            <span>
              This is a guest pass view of a Shoflo event. You can bookmark this
              link for access later. Periodically refresh this page to see new
              updates.
            </span>
          </Col>
          <Col sm={3} xs={24}>
            <div className="printable-cuesheet-action-btns">
              <Icon
                className="printable-cuesheet-update"
                name="refresh"
                onClick={() => window.location.reload()}
              />
              <span
                className="printable-cuesheet-login"
                onClick={() => RouteActions.goToLogin()}
              >
                Login
              </span>
            </div>
          </Col>
        </Row>
      </header>
    );
  },

  _getBodyNode() {
    const eventTitleNode = this._getTitleNode();
    const showListNode = this._getShowListNode();

    return (
      <article className="guest-pass-event-lander-main">
        {eventTitleNode}
        {showListNode}
      </article>
    );
  },

  _getTitleNode() {
    const { cuesheet } = this.state;

    const { event } = this.state;

    if (!event || !cuesheet) return null;

    const team = cuesheet.get('team');

    if (!team) return null;

    const logo = event.get('photo') || team.get('photo') || null;

    const logoNode = logo ? (
      <div className="guest-pass-event-lander-photo-wrapper">
        <img role="presentation" src={logo} />
      </div>
    ) : null;

    return (
      <div className="guest-pass-event-title-wrapper">
        {logoNode}
        <h1>{event.get('title')}</h1>
        <div className="guest-pass-event-date-range">
          <EventDateRange event={event} />
        </div>
      </div>
    );
  },

  _getShowListNode() {
    const { cuesheet, event, shows } = this.state;

    const team = cuesheet.get('team');

    if (!team || !event || !shows) return null;

    const { origin } = window.location;

    const showList = shows.map((show) => {
      if (show.get('disableGuestPass') || show.get('archived')) return null;

      const isV2 = show.get('displayType') === 'rundown';
      const showUrl = isV2
        ? `${origin}/rundown/team/${team.get('_id')}/event/${event.get(
            '_id',
          )}/show/${show.get('_id')}/guest`
        : `${origin}/teams/${team.get('_id')}/events/${event.get(
            '_id',
          )}/shows/${show.get('_id')}/guest`;

      return (
        <div className="guest-pass-event-lander-show-title-wrapper">
          <a className="pointer" href={showUrl}>
            {show.get('title')}
          </a>
        </div>
      );
    });

    return (
      <div className="guest-pass-event-lander-show-wrapper">
        <Col>{showList}</Col>
      </div>
    );
  },
});
